module.exports = __webpack_public_path__ + "static/media/entelicloud-deploy.d1ccf6cb.svg";